import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import Base from "./Base";
import { computed, makeObservable, observable, reaction, runInAction } from "mobx";
import DeliveryModel from "./models/DeliveryModel";
import TimesModel from "./models/TimeModel";
import DPServices, { UserTypes } from "@dp/services";
import { formatDate, ORDER_TYPES, PlatformType } from "@dp/common";
import moment from "moment";
import { fetchDistances } from "../utils";
import orderBy from "lodash/orderBy";
var Delivery = (_class = /*#__PURE__*/function (_Base) {
  _inherits(Delivery, _Base);

  var _super = _createSuper(Delivery);

  function Delivery(rootStore) {
    var _this;

    _classCallCheck(this, Delivery);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _defineProperty(_assertThisInitialized(_this), "deliveryModel", void 0);

    _defineProperty(_assertThisInitialized(_this), "timeModel", null);

    _defineProperty(_assertThisInitialized(_this), "appMessages", null);

    _initializerDefineProperty(_assertThisInitialized(_this), "_isDeliveryLoading", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isDeliveryPageLoading", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isDeliverySwitchLoading", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_showHeaderHamburgerMenu", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_storeName", _descriptor5, _assertThisInitialized(_this));

    _this.rootStore = rootStore;
    _this.appMessages = rootStore.appMessages;
    _this.deliveryModel = new DeliveryModel(_this.rootStore.platformUtil);
    _this.timeModel = new TimesModel(_this.rootStore.platformUtil);
    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Delivery, [{
    key: "_processSessionDetails",
    value: function _processSessionDetails(session) {
      var _this$deliveryModel, _this$timeModel, _session$successRespo, _session$successRespo2;

      this === null || this === void 0 ? void 0 : (_this$deliveryModel = this.deliveryModel) === null || _this$deliveryModel === void 0 ? void 0 : _this$deliveryModel.setSessionDetails(session);
      this.timeModel.resetTimeModel();
      this === null || this === void 0 ? void 0 : (_this$timeModel = this.timeModel) === null || _this$timeModel === void 0 ? void 0 : _this$timeModel.setSessionDetails(session);
      this.deliveryModel.noOfGuests = session === null || session === void 0 ? void 0 : (_session$successRespo = session.successResponse) === null || _session$successRespo === void 0 ? void 0 : (_session$successRespo2 = _session$successRespo.deliveryGroup) === null || _session$successRespo2 === void 0 ? void 0 : _session$successRespo2.partySize;
    }
  }, {
    key: "setupReactions",
    value: function setupReactions() {
      var _this2 = this; //session-details


      reaction(function () {
        var _this2$rootStore, _this2$rootStore$user;

        return {
          sessionDetails: _this2 === null || _this2 === void 0 ? void 0 : (_this2$rootStore = _this2.rootStore) === null || _this2$rootStore === void 0 ? void 0 : (_this2$rootStore$user = _this2$rootStore.user) === null || _this2$rootStore$user === void 0 ? void 0 : _this2$rootStore$user.sessionDetails
        };
      }, /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this2._processSessionDetails(data === null || data === void 0 ? void 0 : data.sessionDetails);

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "fetchTimes",
    value: function () {
      var _fetchTimes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$deliveryModel2,
            _this$deliveryModel2$,
            _this3 = this;

        var realtime,
            isPickup,
            capacitySlotsEnabled,
            restaurantID,
            selectedDate,
            retry,
            resturantId,
            derrivedDate,
            orderType,
            timesResponse,
            _this$appMessages,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                realtime = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
                isPickup = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
                capacitySlotsEnabled = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : true;
                restaurantID = _args2.length > 3 ? _args2[3] : undefined;
                selectedDate = _args2.length > 4 ? _args2[4] : undefined;
                retry = _args2.length > 5 ? _args2[5] : undefined;
                resturantId = restaurantID ? restaurantID : (_this$deliveryModel2 = this.deliveryModel) === null || _this$deliveryModel2 === void 0 ? void 0 : (_this$deliveryModel2$ = _this$deliveryModel2.deliveryFrom) === null || _this$deliveryModel2$ === void 0 ? void 0 : _this$deliveryModel2$.restaurantId;
                derrivedDate = selectedDate ? selectedDate : this.timeModel.selectedCalendarDate; //revisit this, send date based on

                if (!resturantId) {
                  _context2.next = 28;
                  break;
                }

                _context2.prev = 9;
                orderType = isPickup ? ORDER_TYPES.TOGO_PICKUP : ORDER_TYPES.CATERING_DELIVERY;
                _context2.next = 13;
                return DPServices.Times.getPickupTimes(resturantId, orderType, derrivedDate, realtime, capacitySlotsEnabled, false);

              case 13:
                timesResponse = _context2.sent;

                if (!timesResponse) {
                  _context2.next = 23;
                  break;
                }

                if (!(timesResponse !== null && timesResponse !== void 0 && timesResponse.donotDeliver)) {
                  _context2.next = 20;
                  break;
                }

                this.deliveryModel.donotDeliver = true;
                return _context2.abrupt("return");

              case 20:
                this.deliveryModel.donotDeliver = false;

              case 21:
                runInAction(function () {
                  _this3.timeModel.setCapacitySlotsResponse(timesResponse);

                  _this3.timeModel.setRecentTimeSelectionFromAPi(UserTypes.ERecentTimeSelectionFromAPI.FETCH_TIME_API);

                  _this3.timeModel.setFetchTimeOrderTypeData = orderType;
                });
                this.advanceDateIfNeeded();

              case 23:
                _context2.next = 28;
                break;

              case 25:
                _context2.prev = 25;
                _context2.t0 = _context2["catch"](9);
                (_this$appMessages = this.appMessages) === null || _this$appMessages === void 0 ? void 0 : _this$appMessages.showError("Error", "Something went wrong");

              case 28:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[9, 25]]);
      }));

      function fetchTimes() {
        return _fetchTimes.apply(this, arguments);
      }

      return fetchTimes;
    }()
  }, {
    key: "advanceDateIfNeeded",
    value: function () {
      var _advanceDateIfNeeded = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this$timeModel2, _this$timeModel2$avai;

        var _this$timeModel3;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (((_this$timeModel2 = this.timeModel) === null || _this$timeModel2 === void 0 ? void 0 : (_this$timeModel2$avai = _this$timeModel2.availableSlots) === null || _this$timeModel2$avai === void 0 ? void 0 : _this$timeModel2$avai.length) === 0) {
                  this.timeModel.selectedCalendarDate = moment((_this$timeModel3 = this.timeModel) === null || _this$timeModel3 === void 0 ? void 0 : _this$timeModel3.selectedCalendarDate).add(1, "day").toDate();
                  this.timeModel.selectedTimeSlotFromDD = null;
                  this.fetchTimes();
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function advanceDateIfNeeded() {
        return _advanceDateIfNeeded.apply(this, arguments);
      }

      return advanceDateIfNeeded;
    }()
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this$rootStore, _this$rootStore$platf;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(((_this$rootStore = this.rootStore) === null || _this$rootStore === void 0 ? void 0 : (_this$rootStore$platf = _this$rootStore.platformUtil) === null || _this$rootStore$platf === void 0 ? void 0 : _this$rootStore$platf.PLATFORM_TYPE) !== PlatformType.APP)) {
                  _context4.next = 3;
                  break;
                }

                _context4.next = 3;
                return this.rootStore.platformUtil.hydrateUsingSessionStorage("Delivery", this.deliveryModel);

              case 3:
                this._processSessionDetails(this.rootStore.user.sessionDetails);

                this._processAppAttributes(this.rootStore.common.appAttributes);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "searchAddressSuggestions",
    value: function () {
      var _searchAddressSuggestions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(searchText) {
        var results, _this$appMessages2;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.deliveryModel.setIsSearchResultLoading(true);
                results = null;
                _context5.prev = 2;

                if (!(searchText && searchText.length > 4)) {
                  _context5.next = 9;
                  break;
                }

                _context5.next = 6;
                return DPServices.Location.getMapboxPlaceSuggestions("", searchText, "OG", false, true);

              case 6:
                results = _context5.sent;
                this.deliveryModel.setAddressSuggestionsData(results);
                this.deliveryModel.setIsSearchResultLoading(false);

              case 9:
                _context5.next = 14;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5["catch"](2);
                (_this$appMessages2 = this.appMessages) === null || _this$appMessages2 === void 0 ? void 0 : _this$appMessages2.showError("Error", "Something went wrong");

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[2, 11]]);
      }));

      function searchAddressSuggestions(_x2) {
        return _searchAddressSuggestions.apply(this, arguments);
      }

      return searchAddressSuggestions;
    }()
  }, {
    key: "onDeliveryAddressContinue",
    value: function () {
      var _onDeliveryAddressContinue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var response, pickupLocations, _this$rootStore2, _this$rootStore2$plat, _this$appMessages3;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                this.isDeliveryLoading = true;
                _context6.next = 4;
                return this.setDeliveryAddress();

              case 4:
                response = _context6.sent;

                if (!(response.status === "error")) {
                  _context6.next = 7;
                  break;
                }

                throw response === null || response === void 0 ? void 0 : response.errorResponse;

              case 7:
                _context6.next = 9;
                return this.getDeliveryRestaurants();

              case 9:
                if (!this.deliveryModel.donotDeliver) {
                  _context6.next = 18;
                  break;
                }

                _context6.next = 12;
                return this.getPickupLocations();

              case 12:
                pickupLocations = _context6.sent;
                this.deliveryModel.nearbyRestaurants = pickupLocations;
                this.deliveryModel.isUnableDeliveryLocationPage = true;
                this.deliveryModel.isUnableDeliveryModelOpen = true;
                this.isDeliveryLoading = false;
                return _context6.abrupt("return");

              case 18:
                if (this.deliveryModel.isUnableDeliveryLocationPage) {
                  _context6.next = 22;
                  break;
                }

                (_this$rootStore2 = this.rootStore) === null || _this$rootStore2 === void 0 ? void 0 : (_this$rootStore2$plat = _this$rootStore2.platformUtil) === null || _this$rootStore2$plat === void 0 ? void 0 : _this$rootStore2$plat.navigateToRoute("/delivery/restaurant-date-and-time");
                this.isDeliveryLoading = false;
                return _context6.abrupt("return");

              case 22:
                _context6.next = 28;
                break;

              case 24:
                _context6.prev = 24;
                _context6.t0 = _context6["catch"](0);
                this.isDeliveryLoading = false;
                (_this$appMessages3 = this.appMessages) === null || _this$appMessages3 === void 0 ? void 0 : _this$appMessages3.showError("Error", "Invalid Address");

              case 28:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 24]]);
      }));

      function onDeliveryAddressContinue() {
        return _onDeliveryAddressContinue.apply(this, arguments);
      }

      return onDeliveryAddressContinue;
    }()
  }, {
    key: "setDeliveryAddress",
    value: function setDeliveryAddress() {
      var _this$deliveryModel3, _this$deliveryModel4, _this$deliveryModel5, _this$deliveryModel6;

      var address = (_this$deliveryModel3 = this.deliveryModel) === null || _this$deliveryModel3 === void 0 ? void 0 : _this$deliveryModel3.selectedUserLocation;
      return DPServices.Restaurant.setDeliveryAddress({
        addressLine1: address.addressLine1,
        city: address.city,
        state: address.state,
        zipcode: address.zipCode,
        country: address.countyCode || address.country,
        // countyCode for map box and country for sessionDetails
        addressLine2: (_this$deliveryModel4 = this.deliveryModel) === null || _this$deliveryModel4 === void 0 ? void 0 : _this$deliveryModel4.suiteOrApartmentNumber,
        companyName: (_this$deliveryModel5 = this.deliveryModel) === null || _this$deliveryModel5 === void 0 ? void 0 : _this$deliveryModel5.otherDetails,
        type: (_this$deliveryModel6 = this.deliveryModel) === null || _this$deliveryModel6 === void 0 ? void 0 : _this$deliveryModel6.selectedAddressType
      });
    }
  }, {
    key: "getDeliveryRestaurants",
    value: function () {
      var _getDeliveryRestaurants = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _this$deliveryModel7, _this$deliveryModel8, results, _this$timeModel4, pickupLocations, _this$appMessages4;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                this.isDeliveryLoading = true;
                _context7.next = 4;
                return DPServices.Restaurant.getDeliveryRestaurants((_this$deliveryModel7 = this.deliveryModel) === null || _this$deliveryModel7 === void 0 ? void 0 : _this$deliveryModel7.selectedUserLocationCoordinates, (_this$deliveryModel8 = this.deliveryModel) === null || _this$deliveryModel8 === void 0 ? void 0 : _this$deliveryModel8.locationSearchString);

              case 4:
                results = _context7.sent;
                this.deliveryModel.isDeliveryRestaurantApiCallStatus = true;
                this.deliveryModel.deliveryRestaurantsAvailable = results === null || results === void 0 ? void 0 : results.deliveryLocations;
                this.deliveryModel.nearbyRestaurants = results === null || results === void 0 ? void 0 : results.pickUpLocations;

                if (!(results.deliveryResultsCount > 0)) {
                  _context7.next = 17;
                  break;
                }

                this.deliveryModel.deliveryFrom = results.deliveryLocations[0];
                this.deliveryModel.isUnableDeliveryLocationPage = false;

                if (moment().isSame(moment((_this$timeModel4 = this.timeModel) === null || _this$timeModel4 === void 0 ? void 0 : _this$timeModel4.selectedCalendarDate), "day")) {
                  this.timeModel.selectedCalendarDate = moment().add(1, "day").toDate();
                  this.timeModel.selectedTimeSlotFromDD = null;
                }

                _context7.next = 14;
                return this.fetchTimes();

              case 14:
                this.isDeliveryLoading = false;
                _context7.next = 24;
                break;

              case 17:
                _context7.next = 19;
                return this.getPickupLocations();

              case 19:
                pickupLocations = _context7.sent;
                this.isDeliveryLoading = false;
                this.deliveryModel.nearbyRestaurants = pickupLocations;
                this.deliveryModel.isUnableDeliveryLocationPage = true;
                this.deliveryModel.isUnableDeliveryModelOpen = true;

              case 24:
                _context7.next = 29;
                break;

              case 26:
                _context7.prev = 26;
                _context7.t0 = _context7["catch"](0);
                (_this$appMessages4 = this.appMessages) === null || _this$appMessages4 === void 0 ? void 0 : _this$appMessages4.showError("Error", "Something went wrong");

              case 29:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 26]]);
      }));

      function getDeliveryRestaurants() {
        return _getDeliveryRestaurants.apply(this, arguments);
      }

      return getDeliveryRestaurants;
    }()
  }, {
    key: "getPickupLocations",
    value: function () {
      var _getPickupLocations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var _this$deliveryModel9;

        var coordsArray, pickupLocations, coordsObj, resultObj, finalLocResults;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                coordsArray = (_this$deliveryModel9 = this.deliveryModel) === null || _this$deliveryModel9 === void 0 ? void 0 : _this$deliveryModel9.selectedUserLocationCoordinates.split(", ");
                pickupLocations = this.deliveryModel.nearbyRestaurants;
                coordsObj = {
                  latitude: Number(coordsArray[0]),
                  longitude: Number(coordsArray[1]),
                  altitude: null,
                  accuracy: null,
                  altitudeAccuracy: null,
                  heading: null,
                  speed: null
                };
                _context8.next = 5;
                return fetchDistances(coordsObj, pickupLocations);

              case 5:
                resultObj = _context8.sent;
                finalLocResults = pickupLocations === null || pickupLocations === void 0 ? void 0 : pickupLocations.map(function (result) {
                  var temp = result;
                  temp.mapBoxDistance = resultObj[result === null || result === void 0 ? void 0 : result.restaurantId];
                  return temp;
                });
                return _context8.abrupt("return", orderBy(finalLocResults, "mapBoxDistance", "asc"));

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getPickupLocations() {
        return _getPickupLocations.apply(this, arguments);
      }

      return getPickupLocations;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "_processAppAttributes",
    value: function () {
      var _processAppAttributes2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(appAttributes) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                this.deliveryModel.setAppAttributes(appAttributes);
                this.timeModel.setAppAttributes(appAttributes);

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function _processAppAttributes(_x3) {
        return _processAppAttributes2.apply(this, arguments);
      }

      return _processAppAttributes;
    }()
  }, {
    key: "setDeliveryTime",
    value: function () {
      var _setDeliveryTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var _this$deliveryModel10, _this$timeModel5, _this$timeModel6, _this$timeModel6$sele, _this$deliveryModel11, _this$rootStore3, _this$rootStore3$user, _this$rootStore$platf2, selectedDeliveryRestaurant, _this$appMessages5, _faults$faults$, faults;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                selectedDeliveryRestaurant = (_this$deliveryModel10 = this.deliveryModel) === null || _this$deliveryModel10 === void 0 ? void 0 : _this$deliveryModel10.deliveryFrom;
                this.isDeliveryLoading = true;
                _context12.next = 5;
                return DPServices.Restaurant.setDeliveryTime(selectedDeliveryRestaurant === null || selectedDeliveryRestaurant === void 0 ? void 0 : selectedDeliveryRestaurant.restaurantId, formatDate((_this$timeModel5 = this.timeModel) === null || _this$timeModel5 === void 0 ? void 0 : _this$timeModel5.selectedCalendarDate), (_this$timeModel6 = this.timeModel) === null || _this$timeModel6 === void 0 ? void 0 : (_this$timeModel6$sele = _this$timeModel6.selectedTimeSlot) === null || _this$timeModel6$sele === void 0 ? void 0 : _this$timeModel6$sele.startTime, (_this$deliveryModel11 = this.deliveryModel) === null || _this$deliveryModel11 === void 0 ? void 0 : _this$deliveryModel11.noOfGuests, selectedDeliveryRestaurant === null || selectedDeliveryRestaurant === void 0 ? void 0 : selectedDeliveryRestaurant.duration, selectedDeliveryRestaurant === null || selectedDeliveryRestaurant === void 0 ? void 0 : selectedDeliveryRestaurant.miles);

              case 5:
                try {
                  if (this.rootStore.menuList) {
                    this.rootStore.menuList.timeModel.setRecentTimeSelectionFromAPi(null);
                    this.rootStore.menuList.timeModel.resetTimeModel();
                    this.rootStore.menuList.timeModel.setPickupTimeResponse(null);
                    this.rootStore.menuList.timeModel.currentRequestedDate = null;
                  }
                } catch (e) {}

                _context12.next = 8;
                return (_this$rootStore3 = this.rootStore) === null || _this$rootStore3 === void 0 ? void 0 : (_this$rootStore3$user = _this$rootStore3.user) === null || _this$rootStore3$user === void 0 ? void 0 : _this$rootStore3$user.updateSession();

              case 8:
                (_this$rootStore$platf2 = this.rootStore.platformUtil) === null || _this$rootStore$platf2 === void 0 ? void 0 : _this$rootStore$platf2.navigateToRoute("/menu");
                this.isDeliveryLoading = false;
                _context12.next = 17;
                break;

              case 12:
                _context12.prev = 12;
                _context12.t0 = _context12["catch"](0);
                this.isDeliveryLoading = false;
                faults = DPServices.Cart.parseErrors(_context12.t0);
                (_this$appMessages5 = this.appMessages) === null || _this$appMessages5 === void 0 ? void 0 : _this$appMessages5.showError("Error", (faults === null || faults === void 0 ? void 0 : (_faults$faults$ = faults.faults[0]) === null || _faults$faults$ === void 0 ? void 0 : _faults$faults$.faultDescription) || "Something went wrong");

              case 17:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 12]]);
      }));

      function setDeliveryTime() {
        return _setDeliveryTime.apply(this, arguments);
      }

      return setDeliveryTime;
    }()
  }, {
    key: "changeDeliveryRestaurant",
    value: function () {
      var _changeDeliveryRestaurant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(item) {
        var _this$deliveryModel12, _this$deliveryModel13;

        var _this$timeModel7;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!(item.restaurantId !== ((_this$deliveryModel12 = this.deliveryModel) === null || _this$deliveryModel12 === void 0 ? void 0 : (_this$deliveryModel13 = _this$deliveryModel12.deliveryFrom) === null || _this$deliveryModel13 === void 0 ? void 0 : _this$deliveryModel13.restaurantId))) {
                  _context13.next = 5;
                  break;
                }

                this.deliveryModel.deliveryFrom = item;

                if (moment().isSame(moment((_this$timeModel7 = this.timeModel) === null || _this$timeModel7 === void 0 ? void 0 : _this$timeModel7.selectedCalendarDate), "day")) {
                  this.timeModel.selectedCalendarDate = moment().add(1, "day").toDate();
                  this.timeModel.selectedTimeSlotFromDD = null;
                }

                _context13.next = 5;
                return this.fetchTimes();

              case 5:
                this.deliveryModel.isSelectRestaurantPopupOpen = false;

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function changeDeliveryRestaurant(_x4) {
        return _changeDeliveryRestaurant.apply(this, arguments);
      }

      return changeDeliveryRestaurant;
    }()
  }, {
    key: "loadDeliveryDateAndTimePage",
    value: function () {
      var _loadDeliveryDateAndTimePage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var _this$deliveryModel14;

        var pickupLocations;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if ((_this$deliveryModel14 = this.deliveryModel) !== null && _this$deliveryModel14 !== void 0 && _this$deliveryModel14.isDeliveryRestaurantApiCallStatus) {
                  _context14.next = 12;
                  break;
                }

                this.isDeliveryPageLoading = true;
                _context14.next = 4;
                return this.getDeliveryRestaurants();

              case 4:
                if (!this.deliveryModel.donotDeliver) {
                  _context14.next = 11;
                  break;
                }

                this.deliveryModel.isUnableDeliveryLocationPage = true;
                this.deliveryModel.isUnableDeliveryModelOpen = true;
                _context14.next = 9;
                return this.getPickupLocations();

              case 9:
                pickupLocations = _context14.sent;
                this.deliveryModel.nearbyRestaurants = pickupLocations;

              case 11:
                this.isDeliveryPageLoading = false;

              case 12:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function loadDeliveryDateAndTimePage() {
        return _loadDeliveryDateAndTimePage.apply(this, arguments);
      }

      return loadDeliveryDateAndTimePage;
    }()
  }, {
    key: "deliveryToPickupSwitch",
    value: function () {
      var _deliveryToPickupSwitch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(restaurantId) {
        var _this$timeModel$avail, startTime;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                this.isDeliveryLoading = true;
                _context15.next = 4;
                return this.fetchTimes(false, true, false, restaurantId, moment().toDate());

              case 4:
                startTime = (_this$timeModel$avail = this.timeModel.availableSlots[0]) === null || _this$timeModel$avail === void 0 ? void 0 : _this$timeModel$avail.startTimeInMs;

                if (!startTime) {
                  _context15.next = 14;
                  break;
                }

                _context15.next = 8;
                return DPServices.Times.setOrderRestaurantAndPickupTime(restaurantId, moment(startTime).toDate(), "togo-pickup-order", false, false);

              case 8:
                _context15.next = 10;
                return this.rootStore.user.updateSession();

              case 10:
                this.isDeliveryLoading = false;
                this.rootStore.platformUtil.navigateToRoute("/menu");
                _context15.next = 16;
                break;

              case 14:
                this.isDeliveryLoading = false;
                this.appMessages.showError("Error", "No pickup time available.");

              case 16:
                _context15.next = 22;
                break;

              case 18:
                _context15.prev = 18;
                _context15.t0 = _context15["catch"](0);
                this.isDeliveryLoading = false;
                this.appMessages.showError("Something went wrong", "Delivery to pickup switch failed");

              case 22:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[0, 18]]);
      }));

      function deliveryToPickupSwitch(_x5) {
        return _deliveryToPickupSwitch.apply(this, arguments);
      }

      return deliveryToPickupSwitch;
    }()
  }, {
    key: "onOrderPickupPress",
    value: function () {
      var _onOrderPickupPress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var _this$deliveryModel15, restaurantId, _this$timeModel$avail2, startTime;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                this.isDeliverySwitchLoading = true;
                _context16.prev = 1;
                restaurantId = (_this$deliveryModel15 = this.deliveryModel) === null || _this$deliveryModel15 === void 0 ? void 0 : _this$deliveryModel15.previousRestaurantId;

                if (!restaurantId) {
                  _context16.next = 16;
                  break;
                }

                _context16.next = 6;
                return this.fetchTimes(false, true, false, restaurantId, moment().toDate());

              case 6:
                startTime = (_this$timeModel$avail2 = this.timeModel.availableSlots[0]) === null || _this$timeModel$avail2 === void 0 ? void 0 : _this$timeModel$avail2.startTimeInMs;

                if (!startTime) {
                  _context16.next = 14;
                  break;
                }

                _context16.next = 10;
                return DPServices.Times.setOrderRestaurantAndPickupTime(restaurantId, moment(startTime).toDate(), "togo-pickup-order", false, false);

              case 10:
                _context16.next = 12;
                return this.rootStore.user.updateSession();

              case 12:
                _context16.next = 16;
                break;

              case 14:
                this.isDeliveryLoading = false;
                this.appMessages.showError("Error", "No pickup time available.");

              case 16:
                this.isDeliverySwitchLoading = false;

                if (this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP) {
                  this.rootStore.platformUtil.navigateToRoute("/home");
                } else {
                  this.rootStore.platformUtil.navigateToRoute("/order-online?orderType=delivery");
                }

                _context16.next = 24;
                break;

              case 20:
                _context16.prev = 20;
                _context16.t0 = _context16["catch"](1);
                this.isDeliveryLoading = false;
                this.appMessages.showError("Something went wrong", "Delivery to pickup switch failed");

              case 24:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this, [[1, 20]]);
      }));

      function onOrderPickupPress() {
        return _onOrderPickupPress.apply(this, arguments);
      }

      return onOrderPickupPress;
    }()
  }, {
    key: "isDeliveryLoading",
    get: function get() {
      return this._isDeliveryLoading;
    },
    set: function set(_isDeliveryLoading) {
      var _this4 = this;

      runInAction(function () {
        _this4._isDeliveryLoading = _isDeliveryLoading;
      });
    }
  }, {
    key: "isDeliveryPageLoading",
    get: function get() {
      return this._isDeliveryPageLoading;
    },
    set: function set(_isDeliveryPageLoading) {
      var _this5 = this;

      runInAction(function () {
        _this5._isDeliveryPageLoading = _isDeliveryPageLoading;
      });
    }
  }, {
    key: "isDeliverySwitchLoading",
    get: function get() {
      return this._isDeliverySwitchLoading;
    },
    set: function set(_isDeliverySwitchLoading) {
      var _this6 = this;

      runInAction(function () {
        _this6._isDeliverySwitchLoading = _isDeliverySwitchLoading;
      });
    }
  }, {
    key: "showHeaderHamburgerMenu",
    set: function set(val) {
      var _this7 = this;

      runInAction(function () {
        _this7._showHeaderHamburgerMenu = val;
      });
    },
    get: function get() {
      return this._showHeaderHamburgerMenu;
    }
  }]);

  return Delivery;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_isDeliveryLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_isDeliveryPageLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_isDeliverySwitchLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_showHeaderHamburgerMenu", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_storeName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isDeliveryLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDeliveryLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDeliveryPageLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDeliveryPageLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDeliverySwitchLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDeliverySwitchLoading"), _class.prototype)), _class);
export { Delivery as default };